/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
    async index(data?: any) {
        return camelize(
            await $axios.get(`/style`, snakelize({ params: data }))
        );
    },
});
